import React from "react";
import { BaseButton } from "../share/button";
import { useSwitchNetwork } from "wagmi";

interface IProps {
  onCancel?: () => void;
}

function NotSupportChain({ onCancel }: IProps) {
  const { chains, switchNetwork } = useSwitchNetwork({
    onSuccess() {
      onCancel && onCancel();
    },
  });
  return (
    <div>
      <div className="flex flex-col items-center w-full gap-4 py-4">
        <img className="w-[230px]" src="/icons/image_clould.svg" alt="" />
        <p className="text-base text-center text-main">
          Hiện tại chúng tôi không hỗ trợ mạng này
        </p>
        <div className="bg-yllow-100 text-yellow-700 px-4 py-2 w-full rounded flex items-center gap-2 text-sm">
          <img className="w-6" src="/icons/icon_warnning.svg" alt="" />
          <span>Chuyển đổi mạng của bạn để tiếp tục</span>
        </div>
      </div>
      <BaseButton
        className="w-full mt-3 h-12"
        onClick={() => {
          switchNetwork?.(chains?.[0]?.id);
        }}
      >
        Chuyển đổi mạng
      </BaseButton>
    </div>
  );
}

export default NotSupportChain;
